import React from 'react';
import './SharkHeader.css';

const SharkHeader = () => {
  return (
    <div className="shark-header">
      <img src="logo.png" alt="Shark Logo" className="logo" />
    </div>
  );
};

export default SharkHeader;
